// components/IconExample.jsx
import React from "react";

export default function IconExample({ color = "#BB56FF", ...props }) {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11 21C17.0751 21 22 16.299 22 10.5C22 4.70101 17.0751 0 11 0C4.92487 0 0 4.70101 0 10.5C0 16.299 4.92487 21 11 21Z"
        fill="#8AC9FE"
      />
      <path
        d="M15.7656 1.03394C17.0567 2.75462 17.8169 4.86291 17.8169 7.14087C17.8169 12.9399 12.892 17.6409 6.81688 17.6409C5.10956 17.6409 3.49312 17.2696 2.0513 16.6069C4.04694 19.2666 7.31128 21 11 21C17.0751 21 22 16.299 22 10.5C22 6.33073 19.4543 2.72907 15.7656 1.03394Z"
        fill={color}
      />
      <path
        d="M10.9998 19.6429C16.2898 19.6429 20.5782 15.5495 20.5782 10.4999C20.5782 5.45039 16.2898 1.35693 10.9998 1.35693C5.70984 1.35693 1.42145 5.45039 1.42145 10.4999C1.42145 15.5495 5.70984 19.6429 10.9998 19.6429Z"
        fill="#EAF6FF"
      />
      <path
        d="M17.1259 3.47156C17.5723 4.61384 17.8169 5.84997 17.8169 7.14081C17.8169 12.9398 12.8921 17.6408 6.81693 17.6408C6.12534 17.6408 5.44893 17.5792 4.79276 17.4627C6.46463 18.8221 8.63175 19.6429 11 19.6429C16.29 19.6429 20.5784 15.5495 20.5784 10.5C20.5784 7.67451 19.2355 5.14869 17.1259 3.47156V3.47156Z"
        fill="#D8ECFE"
      />
      <path
        d="M10.8709 5.01391L7.78159 9.76954C7.74429 9.82696 7.76247 9.90235 7.82232 9.9384L10.9738 11.8384C11.0164 11.864 11.0706 11.8637 11.1128 11.8375L14.1788 9.93922C14.2379 9.90264 14.2553 9.82754 14.2178 9.77057L11.0897 5.01329C11.039 4.93622 10.9212 4.93655 10.8709 5.01391V5.01391Z"
        fill={color}
      />
      <path
        d="M11.0875 13.4837L13.7954 11.876C13.9128 11.8063 14.0472 11.938 13.9712 12.0482L11.2428 16.0042C11.1931 16.0763 11.083 16.0784 11.0303 16.0082L8.07799 12.0759C7.99605 11.9668 8.13041 11.8291 8.25025 11.8994L10.9519 13.484C10.9935 13.5084 11.046 13.5083 11.0875 13.4837V13.4837Z"
        fill={color}
      />
    </svg>
  );
}
